import { IconContainer, InputWrapper, PasswordInput } from './styles';
import React, { useState } from 'react';

import { Eye, EyeOff } from 'lucide-react';
import { UDCommonInputProps } from './types';
import classNames from 'classnames';

export type UDPasswordInputProps = UDCommonInputProps;

// TODO: need refactoring
const UDPasswordInput = (props: UDPasswordInputProps) => {
  const { hasError, valid, iconProps, className, wrapperProps, ...othetProps } = props;
  const [masked, setMasked] = useState(true);
  const inputClassName = classNames(
    'input',
    'text subhead',
    props.className,
    {
      '--error': props.hasError,
      masked,
    },
    'icon-right',
  );
  const toggleMask = (e: React.MouseEvent<SVGElement, MouseEvent>) => setMasked((prev) => !prev);
  return (
    <InputWrapper
      {...wrapperProps}
      className={classNames(
        {
          error: hasError,
          valid,
        },
        wrapperProps?.className,
      )}
    >
      {/* @ts-ignore */}
      <PasswordInput
        {...othetProps}
        // @ts-ignore
        onChange={(value) =>
          props?.onChange &&
          // @ts-ignore
          props.onChange({ target: { value, name: props.name || '' } })
        }
        className={inputClassName}
        mask="&#x25A0;"
        show={!masked}
      />
      <IconContainer className="icon-right" style={{ cursor: 'pointer' }}>
        {masked ? (
          <EyeOff size={24} strokeWidth={1.5} onClick={toggleMask} />
        ) : (
          <Eye size={24} strokeWidth={1.5} onClick={toggleMask} />
        )}
      </IconContainer>
    </InputWrapper>
  );
};

export default UDPasswordInput;
